import { createAsyncThunk } from '@reduxjs/toolkit';
import { ProtobufClient } from 'api/protobuf/protobuf-client';
import { goBackendApi } from 'hooks/api/httpApi';
import { mapEveryBigintIntoNumber } from 'utils/map-every-bigint-into-number';
import {
    PackageProvider,
    PackageProvidersResponseSchema,
} from '../../../../pb/responses/v1/package_providers_response_pb';

export const getPackageProviders = createAsyncThunk<PackageProvider[]>(
    '[packageProviders] getPackageProviders',
    async () => {
        const pbClient = new ProtobufClient(goBackendApi());
        return await pbClient
            .getRequest(PackageProvidersResponseSchema, '/api/v2/package-providers')
            .then((res) => {
                return res.packageProviders.map((provider) => mapEveryBigintIntoNumber(provider) as PackageProvider);
            })
            .catch(() => [] as PackageProvider[]);
    }
);
